<main class="app_template_d__container" id="templateContainer">
	<app-print-header></app-print-header>
	<p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
		<ng-template pTemplate="header">
			<label><strong>Esops de exposición: </strong>
				{{ examen.esops?.length }}</label>
		</ng-template>
		<p-scrollPanel [style]="{ height: '200px' }">
			<p-table [value]="examen.esops">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 20%; text-align: center;">Código</th>
						<th style="width: 80%; text-align: center;">Concepto</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td style="text-align: center;">{{ item.codigo }}</td>
						<td style="text-align: center;">{{ item.descripcion }}</td>
					</tr>
				</ng-template>
			</p-table>
		</p-scrollPanel>
		<p-footer>
			<p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
		</p-footer>
	</p-dialog>


	<form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
		<div class="form-container p-fluid">


			<div class="p-grid p-jc-between" style="margin-bottom: 15px;">
				<div class="" style="display: flex;">
					<span>
						<i (click)="goBack()" class="pi pi-arrow-left"
							style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
					</span>
					<label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
				</div>

				<span class="print_hide-on-print">
					<app-print-button></app-print-button>
				</span>
			</div>

			<div class="p-grid">
				<div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
					<app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
					<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						{{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
					</span>

					<p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date"
						dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init"
						[maxDate]="maxDate" [minDate]="minDate" class="print_hide-on-print"
						[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
						[disabled]="examen?.modoVista === 'ver'">
					</p-calendar>

					<app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid">
					</app-invalid-from-message>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Lote"></app-fiel-title>
					<p class="readOnly">
						{{examen.lote.numeroLote}}
					</p>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Carpeta"></app-fiel-title>
					<p class="readOnly">
						{{examen.numeroCarpeta}}
					</p>
				</div>

				<div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
					<label class="color-text" (click)="displayAgentes = true">
						Esops de exposición ({{ examen.esops?.length }})</label>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Empleador')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Empleador") }}. Datos de la empresa
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid">
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Razón Social"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIT"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Establecimiento"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Teléfono"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Dirección de E-mail"></app-fiel-title>
						<p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Trabajador')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Trabajador") }}. Datos Del Trabajador
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
						  formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
						  [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.apellidoNombre.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
											message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
										</app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIL"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.cuil}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
						  placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
						  [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
						  (onSelect)="calculateAge()" (onBlur)="calculateAge()"
						  [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="DNI"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.numeroDocumento}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Sexo"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.sexo}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full p_hidden">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">
							{{ getDescripcionDomicilio() }}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Edad"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.edad }} años
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}"
							alfanumericoDirective formControlName="puestoTrabajador" id="puesto" name="puesto"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.puestoTrabajador.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
							[disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
							[minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
							(onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('DescripcionBreveTrabajoHabitual')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("DescripcionBreveTrabajoHabitual") }}. Descripción breve de su
						trabajo habitual
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="true" class="print_hide-on-print"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('desTrabHab')" class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.desTrabHab.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.desTrabHab.invalid}" cols="30"
								formControlName="desTrabHab" id="result" maxlength="1000" name="resul" pInputTextarea
								rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.desTrabHab.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.desTrabHab.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.desTrabHab.errors?.maxlength"
								message="Solo se permiten {{ f.desTrabHab.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('AntecedentesLaboralesMismaActividad')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("AntecedentesLaboralesMismaActividad") }}. Antecedentes
						laborales en la misma actividad
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Antecedentes laborales en la misma actividad: " required="true" class="print_hide-on-print">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('antLaboralSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('antLaboralSi', $event)" binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.antLaboralSi.value && !f.antLaboralNo.value}"
										formControlName="antLaboralSi" inputId="antLaboralSi" label="Si"
										name="antLaboralSi" [ngModel]="examen.antLaboral"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('antLaboralNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('antLaboralNo', $event)" binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.antLaboralSi.value && !f.antLaboralNo.value}"
										formControlName="antLaboralNo" inputId="antLaboralNo" label="No"
										name="antLaboralNo" [ngModel]="examen.antLaboral === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message
								*ngIf="submitted && !f.antLaboralSi.value  && !f.antLaboralNo.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="f.antLaboralSi.value"
								[ngClass]="{'print_hide-on-print': f.antLaboralNo.value === true}"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('desAntLaboral')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.antLaboralNo.value !== true, 'print_hide-on-print': f.antLaboralNo.value === true}"
								class="print_hidden-area-before-print print_row-full p-field-word-break">
								{{f.desAntLaboral.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.desAntLaboral.invalid}" cols="30"
								formControlName="desAntLaboral" id="result" maxlength="1000" name="resul" pInputTextarea
								rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.desAntLaboral.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.desAntLaboral.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.desAntLaboral.errors?.maxlength"
								message="Solo se permiten {{ f.desAntLaboral.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('TiempoDeTarea')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("TiempoDeTarea") }}. Tiempo de tarea
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-field-without-border p-col-12 p-md-12 print_row-full print_row-fill-block">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Tiempo de tarea: " required="true" class="print_hide-on-print"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div *ngFor="let item of tiempoTareaValues" class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.tiempoTarea.value}"
								[value]="item.value"
								formControlName="tiempoTarea"
								[label]="item.label"
								name="tiempoTarea"
								[ngModel]="examen.tiempoTarea"
								[disabled]="examen?.modoVista === 'ver'">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && !f.tiempoTarea.value">
					</app-invalid-from-message>
				</div>
				<div class="p-grid p-grid-space p-field-without-borde ">
					<div *ngIf="configForm.findField('tiempoHoras')"
						class="p-field p-col-12 p-md-4 p-field-without-border">
						<div class="print_row-full">
							<app-fiel-title label="Nº de hora de trabajo diario:" required="true"></app-fiel-title>
							<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
								{{examForm.controls.tiempoHoras.value}}
							</span>
							<input [ngClass]="{'ng-invalid ng-dirty':submitted && f.tiempoHoras.invalid}"
								formControlName="tiempoHoras" id="horastrabajo" maxlength="3" name="horastrabajo"
								numberDirective pInputText type="text" [ngModel]="examen.tiempoHoras"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
							<app-invalid-from-message *ngIf="submitted && f.tiempoHoras.invalid">
							</app-invalid-from-message>
						</div>
					</div>
					<div *ngIf="configForm.findField('tiempoSemanas')" class="p-field p-col-12 p-md-4 p-field-without-border">
						<div class="print_row-full">
							<app-fiel-title label="Nº de hora de trabajo semanales:" required="true"></app-fiel-title>
							<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
								{{examForm.controls.tiempoSemanas.value}}
							</span>
							<input [ngClass]="{'ng-invalid ng-dirty':submitted && f.tiempoSemanas.invalid}"
								formControlName="tiempoSemanas" id="horastrabajo" maxlength="3" name="horastrabajo"
								numberDirective pInputText type="text" [ngModel]="examen.tiempoSemanas"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
							<app-invalid-from-message *ngIf="submitted && f.tiempoSemanas.invalid">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('ManipulacionCarga')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("ManipulacionCarga") }}. Manipulación manual de cargas
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-field p-col-12 p-md-12 print_row-full print_row-fill-block p-field-without-border">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Manipulación manual de cargas: " required="true" class="print_hide-on-print"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4" *ngFor="let item of manipulacionCargaValues">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.manipulacionCarga.value}"
								[value]="item.value"
								formControlName="manipulacionCarga"
								name="manipulacionCarga"
								[ngModel]="examen.manipulacionCarga"
								[label]="item.label"
								[disabled]="examen?.modoVista === 'ver'">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && !f.manipulacionCarga.value">
					</app-invalid-from-message>
				</div>
			</div>

			<div *ngIf="configForm.findSection('CicloTrabajo')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("CicloTrabajo") }}. Ciclo de trabajo
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-field p-col-12 p-md-12 print_row-full print_row-fill-block p-field-without-border">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Ciclo de trabajo: " required="true" class="print_hide-on-print"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4" *ngFor="let item of cicloTrabajoValues">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.cicloTrabajo.value}"
								[value]="item.value"
								formControlName="cicloTrabajo"
								name="cicloTrabajo"
								[ngModel]="examen.cicloTrabajo"
								[label]="item.label"
								[disabled]="examen?.modoVista === 'ver'">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && !f.cicloTrabajo.value">
					</app-invalid-from-message>
				</div>
			</div>

			<div *ngIf="configForm.findSection('TipoDeTarea')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("TipoDeTarea") }}. Tipo de tarea
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Movimientos de alcance repetidos por encima del hombro: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoMovHombroSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoMovHombroSi', $event)" binary="true"
										formControlName="tipoMovHombroSi" inputId="tipoMovHombroSi" label="Si"
										name="tipoMovHombroSi" [ngModel]="examen.tipoMovHombro"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoMovHombroNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoMovHombroNo', $event)" binary="true"
										formControlName="tipoMovHombroNo" inputId="tipoMovHombroNo" label="No"
										name="tipoMovHombroNo" [ngModel]="examen.tipoMovHombro === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Movimientos de flexión o extensión forzados de muñeca: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoMovMunecaSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoMovMunecaSi', $event)" binary="true"
										formControlName="tipoMovMunecaSi" inputId="tipoMovMunecaSi" label="Si"
										name="tipoMovMunecaSi" [ngModel]="examen.tipoMovMuneca"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoMovMunecaNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoMovMunecaNo', $event)" binary="true"
										formControlName="tipoMovMunecaNo" inputId="tipoMovMunecaNo" label="No"
										name="tipoMovMunecaNo" [ngModel]="examen.tipoMovMuneca === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Compresión de nervio a través de dos vientres musculares: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoMovNervioSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoMovNervioSi', $event)" binary="true"
										formControlName="tipoMovNervioSi" inputId="tipoMovNervioSi" label="Si"
										name="tipoMovNervioSi" [ngModel]="examen.tipoMovNervio"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoMovNervioNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoMovNervioNo', $event)" binary="true"
										formControlName="tipoMovNervioNo" inputId="tipoMovNervioNo" label="No"
										name="tipoMovNervioNo" [ngModel]="examen.tipoMovNervio === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Desviaciones cubitales o radiales forzadas de muñeca: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoMovCubitalesSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoMovCubitalesSi', $event)" binary="true"
										formControlName="tipoMovCubitalesSi" inputId="tipoMovCubitalesSi" label="Si"
										name="tipoMovCubitalesSi" [ngModel]="examen.tipoMovCubitales"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoMovCubitalesNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoMovCubitalesNo', $event)" binary="true"
										formControlName="tipoMovCubitalesNo" inputId="tipoMovCubitalesNo" label="No"
										name="tipoMovCubitalesNo" [ngModel]="examen.tipoMovCubitales === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Otros: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoOtroSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoOtroSi', $event)" binary="true"
										formControlName="tipoOtroSi" inputId="tipoOtroSi" label="Si" name="tipoOtroSi"
										[ngModel]="examen.tipoOtro" [disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoOtroNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoOtroNo', $event)" binary="true"
										formControlName="tipoOtroNo" inputId="tipoOtroNo" label="No" name="tipoOtroNo"
										[ngModel]="examen.tipoOtro === false" [disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="p-grid" [ngClass]="{'print_hide-on-print': f.tipoOtroSi.value !== true}">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Especificar: " [required]="f.tipoOtroSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('descTipoOtro')" class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.descTipoOtro.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.descTipoOtro.invalid}" cols="30"
								formControlName="descTipoOtro" id="result" maxlength="1000" name="resul" pInputTextarea
								rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.descTipoOtro.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.descTipoOtro.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.descTipoOtro.errors?.maxlength"
								message="Solo se permiten {{ f.descTipoOtro.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="El cuello se mantiene flexionado: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoCuelloSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoCuelloSi', $event)" binary="true"
										formControlName="tipoCuelloSi" inputId="tipoCuelloSi" label="Si"
										name="tipoCuelloSi" [ngModel]="examen.tipoCuello"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoCuelloNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoCuelloNo', $event)" binary="true"
										formControlName="tipoCuelloNo" inputId="tipoCuelloNo" label="No"
										name="tipoCuelloNo" [ngModel]="examen.tipoCuello === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Giros de columna: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoColumnaSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoColumnaSi', $event)" binary="true"
										formControlName="tipoColumnaSi" inputId="tipoColumnaSi" label="Si"
										name="tipoColumnaSi" [ngModel]="examen.tipoColumna"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoColumnaNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoColumnaNo', $event)" binary="true"
										formControlName="tipoColumnaNo" inputId="tipoColumnaNo" label="No"
										name="tipoColumnaNo" [ngModel]="examen.tipoColumna === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Rotación extrema del antebrazo: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoRotAntebrazoSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoRotAntebrazoSi', $event)" binary="true"
										formControlName="tipoRotAntebrazoSi" inputId="tipoRotAntebrazoSi" label="Si"
										name="tipoRotAntebrazoSi" [ngModel]="examen.tipoRotAntebrazo"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoRotAntebrazoNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoRotAntebrazoNo', $event)" binary="true"
										formControlName="tipoRotAntebrazoNo" inputId="tipoRotAntebrazoNo" label="No"
										name="tipoRotAntebrazoNo" [ngModel]="examen.tipoRotAntebrazo === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Flexión extrema del codo: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoFlexCodoSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoFlexCodoSi', $event)" binary="true"
										formControlName="tipoFlexCodoSi" inputId="tipoFlexCodoSi" label="Si"
										name="tipoFlexCodoSi" [ngModel]="examen.tipoFlexCodo"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoFlexCodoNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoFlexCodoNo', $event)" binary="true"
										formControlName="tipoFlexCodoNo" inputId="tipoFlexCodoNo" label="No"
										name="tipoFlexCodoNo" [ngModel]="examen.tipoFlexCodo === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Flexión mantenida de dedos: ">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('tipoFlexDedoSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('tipoFlexDedoSi', $event)" binary="true"
										formControlName="tipoFlexDedoSi" inputId="tipoFlexDedoSi" label="Si"
										name="tipoFlexDedoSi" [ngModel]="examen.tipoFlexDedo"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('tipoFlexDedoNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('tipoFlexDedoNo', $event)" binary="true"
										formControlName="tipoFlexDedoNo" inputId="tipoFlexDedoNo" label="No"
										name="tipoFlexDedoNo" [ngModel]="examen.tipoFlexDedo === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('HerramientasElementosUtilizaDiario')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("HerramientasElementosUtilizaDiario") }}. Herramientas y
						elementos que utiliza a diario
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid" [ngClass]="{'print_hide-on-print': f.cicloDescHerramientas.value.length < 1}">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describir: " class="print_hide-on-print"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('cicloDescHerramientas')"
							class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.cicloDescHerramientas.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.cicloDescHerramientas.invalid}"
								cols="30" formControlName="cicloDescHerramientas" id="result" maxlength="1000"
								name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.cicloDescHerramientas.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="f.cicloDescHerramientas.errors?.maxlength"
								message="Solo se permiten {{ f.cicloDescHerramientas.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('TurnosDeTrabajo')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("TurnosDeTrabajo") }}. Turnos de trabajo
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid" [ngClass]="{'print_hide-on-print': f.cicloTurnoTrab.value.length < 1}">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describir: " class="print_hide-on-print"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('cicloTurnoTrab')" class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.cicloTurnoTrab.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.cicloTurnoTrab.invalid}" cols="30"
								formControlName="cicloTurnoTrab" id="result" maxlength="1000" name="resul"
								pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.cicloTurnoTrab.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="f.cicloTurnoTrab.errors?.maxlength"
								message="Solo se permiten {{ f.cicloTurnoTrab.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('PausasTrabajo')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("PausasTrabajo") }}. Pausas en el trabajo
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid" [ngClass]="{'print_hide-on-print': f.cicloPausaTrab.value.length < 1}">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describir: " class="print_hide-on-print"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('cicloPausaTrab')" class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.cicloPausaTrab.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.cicloPausaTrab.invalid}" cols="30"
								formControlName="cicloPausaTrab" id="result" maxlength="1000" name="resul"
								pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.cicloPausaTrab.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="f.cicloPausaTrab.errors?.maxlength"
								message="Solo se permiten {{ f.cicloPausaTrab.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('FlexionColumna')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("FlexionColumna") }}. Flexión sostenida de columna
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Flexión sostenida de columna: " required="true" class="print_hide-on-print">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('flexionSostenidaColSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('flexionSostenidaColSi', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.flexionSostenidaColSi.value && !f.flexionSostenidaColNo.value}"
										formControlName="flexionSostenidaColSi" inputId="flexionSostenidaColSi"
										label="Si" name="flexionSostenidaColSi" [ngModel]="examen.flexionSostenidaCol"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('flexionSostenidaColNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('flexionSostenidaColNo', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.flexionSostenidaColSi.value && !f.flexionSostenidaColNo.value}"
										formControlName="flexionSostenidaColNo" inputId="flexionSostenidaColNo"
										label="No" name="flexionSostenidaColNo"
										[ngModel]="examen.flexionSostenidaCol === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message
								*ngIf="submitted && !f.flexionSostenidaColSi.value  && !f.flexionSostenidaColNo.value">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('MovilidadDolor')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("MovilidadDolor") }}. Movilidad dolor
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Movilidad dolor: " required="true" class="print_hide-on-print">
							</app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('sinParticularidades')" class="p-col-4 p-md-4">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('sinParticularidades', $event)" binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.sinParticularidades.value && !f.miembrosSuperiores.value && !f.miembrosInferiores.value}"
										formControlName="sinParticularidades" inputId="sinParticularidades"
										label="Sin particularidades" name="sinParticularidades" [ngModel]="examen.sinParticularidades"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('miembrosSuperiores')" class="p-col-4 p-md-4">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('miembrosSuperiores', $event)" binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.sinParticularidades.value && !f.miembrosSuperiores.value && !f.miembrosInferiores.value}"
										formControlName="miembrosSuperiores" inputId="miembrosSuperiores"
										label="Miembros Superiores" name="miembrosSuperiores"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('miembrosInferiores')" class="p-col-4 p-md-4">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('miembrosInferiores', $event)" binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.sinParticularidades.value && !f.miembrosSuperiores.value && !f.miembrosInferiores.value}"
										formControlName="miembrosInferiores" inputId="miembrosInferiores"
										label="Miembros Inferiores" name="miembrosInferiores"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message
								*ngIf="submitted && !f.sinParticularidades.value  && !f.miembrosSuperiores.value && !f.miembrosInferiores.value">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div>
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Articulaciones") }}. Articulaciones
					</span>
				</div>
				<p-divider></p-divider>
				<div class="print_dont_break">
					<div *ngIf="configForm.findSection('Segmento Superior') && !f.sinParticularidades.value && f.miembrosSuperiores.value">
						<div class="p-grid">
							<div class="p-col-12 p-md-12 print_header_table">
								<span
									class="p-subtitle-seccion print_show-on-print print_title_table_center">{{configForm.findSection('Segmento Superior')}}</span>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findSection('Segmento tabla') && !f.sinParticularidades.value && f.miembrosSuperiores.value">
						<div class="p-grid ">
							<div class="p-col-12 p-md-12" style="padding: 0px !important;">
								<p-table [value]="salesMMSS">
									<ng-template pTemplate="header">
										<tr>
											<th colspan="3" class="print_table_th_width">Articulación</th>
											<th>Abducción</th>
											<th>Aducción</th>
											<th>Flexión</th>
											<th>Extensión</th>
											<th>Rotación externa</th>
											<th>Rotación interna</th>
											<th>Irradiación</th>
											<th>Alt. Masa Muscular</th>
										</tr>
									</ng-template>
									<ng-template let-sale pTemplate="body">
										<tr>
											<td rowspan="2" colspan="2">{{sale.name}}</td>
											<td>Der</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.abduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.abduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.aduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.aduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.flexion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.flexion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.extencion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.extencion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.der.rotacionExterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.rotacionExterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.der.rotacionInterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.rotacionInterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.irradiacion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.irradiacion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.alteracionMasaMuscular"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.alteracionMasaMuscular)}}
													</ng-template>
												</p-cellEditor>
											</td>
										</tr>
										<tr>
											<td>Izq</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.abduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.abduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.aduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.aduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.flexion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.flexion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.extencion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.extencion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.izq.rotacionExterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.rotacionExterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.izq.rotacionInterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.rotacionInterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.irradiacion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.irradiacion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.alteracionMasaMuscular"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.alteracionMasaMuscular)}}
													</ng-template>
												</p-cellEditor>
											</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</div>
					</div>
				</div>
				<br>
				<div *ngIf="configForm.findSection('Evaluacion clinica final')"
					class="print_table_caracterizacion print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Signos y síntomas MMSS: " required="true"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid-custom">
						<div class="rowspan_caracterizacion_25">
							<label style="text-align: center;">Caracterización semiológica</label>
						</div>
						<div class="rowspan_caracterizacion_75" style="padding: 0px">
							<div class="p-grid-custom-margin" *ngFor="let item of tiposCaracterizacionSemiologicaMMSS">
								<div class=" p-grid-border-bottom" style="width: 100px; text-align: center;">
									{{item.descripcionCodigo}}
								</div>
								<div class="p-grid-border-bottom p-text-center" style="width: 100px">
									<p-radioButton [disabled]="examen.modoVista === 'ver' || f.sinParticularidades.value || !f.miembrosSuperiores.value" class="p-radiobutton-table"
										[ngClass]="{'ng-invalid ng-dirty':(submitted && f.tipoCaracterizacionSemiologicaMMSS.invalid)}"
										(click)="clickRadioButton('tipoCaracterizacionSemiologicaMMSS')"
										[value]="item.codigo" formControlName="tipoCaracterizacionSemiologicaMMSS"
										name="tipoCaracterizacionSemiologicaMMSS"
										[ngModel]="examen.tipoCaracterizacionSemiologicaMMSS">
									</p-radioButton>
								</div>
								<div class="p-grid-border-bottom width-100">
									{{item.descripcion}}
								</div>
							</div>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && f.tipoCaracterizacionSemiologicaMMSS.invalid">
					</app-invalid-from-message>
				</div>
				<br>
				<div *ngIf="!f.sinParticularidades.value && f.miembrosSuperiores.value"
					class="p-field p-col-12 p-md-12 print_row-full print_row-fill-block p-field-without-border print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Dolor MMSS: " [required]="getEnableDoloresMMSS()"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{ 'ng-invalid ng-dirty': submitted && !f.dolorInsidiosoMmss.value &&
							  !f.dolorAgudoMmss.value}" [value]="true" (click)="clickRadioButton('dolorAgudoMmss')"
								formControlName="dolorAgudoMmss" label="Dolor Agudo" name="dolorAgudoMmss"
								[disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMSS()" [(ngModel)]="examen.dolorAgudoMmss">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.dolorInsidiosoMmss.value &&
							  !f.dolorAgudoMmss.value}" [value]="true" (click)="clickRadioButton('dolorInsidiosoMmss')"
								formControlName="dolorInsidiosoMmss" label="Dolor Insidioso" name="dolorInsidiosoMmss"
								[disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMSS()" [(ngModel)]="examen.dolorInsidiosoMmss">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message
						*ngIf="submitted && !isValidDoloresMMSS()">
					</app-invalid-from-message>
				</div>
				<div *ngIf="!f.sinParticularidades.value && f.miembrosSuperiores.value"
					class="p-field p-col-12 p-md-12 print_row-full print_row-fill-block p-field p-field-without-border print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Curso del dolor MMSS: " [required]="getEnableDoloresMMSS()"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.cursoContinuoMmss.value &&
							  !f.cursoBrotesMmss.value && !f.cursoCiclicoMmss.value }" [value]="true"
								(click)="clickRadioButton('cursoContinuoMmss')" formControlName="cursoContinuoMmss"
								label="Continuo" name="cursoContinuoMmss" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMSS()"
								[(ngModel)]="examen.cursoContinuoMmss">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{ 'ng-invalid ng-dirty': submitted && !f.cursoContinuoMmss.value &&
							  !f.cursoBrotesMmss.value && !f.cursoCiclicoMmss.value}" [value]="true"
								(click)="clickRadioButton('cursoBrotesMmss')" formControlName="cursoBrotesMmss"
								label="Brotes" name="cursoBrotesMmss" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMSS()"
								[(ngModel)]="examen.cursoBrotesMmss">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty':submitted &&!f.cursoContinuoMmss.value &&
							  !f.cursoBrotesMmss.value  &&!f.cursoCiclicoMmss.value  }" [value]="true"
								(click)="clickRadioButton('cursoCiclicoMmss')" formControlName="cursoCiclicoMmss"
								label="Cíclico" name="cursoCiclicoMmss" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMSS()"
								[(ngModel)]="examen.cursoCiclicoMmss">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message
						*ngIf="submitted && !isValidCursoMMSS()">
					</app-invalid-from-message>
				</div>
				<div class="print_dont_break">
					<div *ngIf="configForm.findSection('Segmento Inferior') && !f.sinParticularidades.value && f.miembrosInferiores.value">
						<div class="p-grid">
							<div class="p-col-12 p-md-12 print_header_table">
								<span
									class="p-subtitle-seccion print_show-on-print print_title_table_center">{{configForm.findSection('Segmento Inferior')}} </span>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findSection('Segmento tabla') && !f.sinParticularidades.value && f.miembrosInferiores.value">
						<div class="p-grid ">
							<div class="p-col-12 p-md-12" style="padding: 0px !important;">
								<p-table [value]="salesMMII">
									<ng-template pTemplate="header">
										<tr>
											<th colspan="3" class="print_table_th_width">Articulación</th>
											<th>Abducción</th>
											<th>Aducción</th>
											<th>Flexión</th>
											<th>Extensión</th>
											<th>Rotación externa</th>
											<th>Rotación interna</th>
											<th>Irradiación</th>
											<th>Alt. Masa Muscular</th>
										</tr>
									</ng-template>
									<ng-template let-sale pTemplate="body">
										<tr>
											<td rowspan="2" colspan="2">{{sale.name}}</td>
											<td>Der</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.abduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.abduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.aduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.aduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.flexion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.flexion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.extencion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.extencion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.der.rotacionExterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.rotacionExterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.der.rotacionInterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.rotacionInterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.irradiacion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.irradiacion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.der.alteracionMasaMuscular"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.der.alteracionMasaMuscular)}}
													</ng-template>
												</p-cellEditor>
											</td>
										</tr>
										<tr>
											<td>Izq</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.abduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.abduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.aduccion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.aduccion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.flexion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.flexion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.extencion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.extencion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.izq.rotacionExterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.rotacionExterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses"
															[(ngModel)]="sale.izq.rotacionInterna"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.rotacionInterna)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.irradiacion"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.irradiacion)}}
													</ng-template>
												</p-cellEditor>
											</td>
											<td pEditableColumn [pEditableColumnDisabled]="examen.modoVista === 'ver'">
												<p-cellEditor>
													<ng-template pTemplate="input">
														<p-dropdown [options]="statuses" [(ngModel)]="sale.izq.alteracionMasaMuscular"
															[ngModelOptions]="{standalone: true}"></p-dropdown>
													</ng-template>
													<ng-template pTemplate="output">
														{{getLabelStatus(sale.izq.alteracionMasaMuscular)}}
													</ng-template>
												</p-cellEditor>
											</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</div>
					</div>
				</div>
				<br>
				<div *ngIf="configForm.findSection('Evaluacion clinica final')"
					class="print_table_caracterizacion print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Signos y síntomas MMII: " required="true"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid-custom">
						<div class="rowspan_caracterizacion_25">
							<label style="text-align: center;">Caracterización semiológica</label>
						</div>
						<div class="rowspan_caracterizacion_75" style="padding: 0px">
							<div class="p-grid-custom-margin" *ngFor="let item of tiposCaracterizacionSemiologica">
								<div class=" p-grid-border-bottom" style="width: 100px; text-align: center;">
									{{item.descripcionCodigo}}
								</div>
								<div class=" p-grid-border-bottom p-text-center" style="width: 100px">
									<p-radioButton [disabled]="examen.modoVista === 'ver' || f.sinParticularidades.value || !f.miembrosInferiores.value" class="p-radiobutton-table"
										[ngClass]="{'ng-invalid ng-dirty':(submitted && f.tipoCaracterizacionSemiologicaMMII.invalid)}"
										(click)="clickRadioButton('tipoCaracterizacionSemiologicaMMII')"
										[value]="item.codigo" formControlName="tipoCaracterizacionSemiologicaMMII"
										name="tipoCaracterizacionSemiologicaMMII"
										[ngModel]="examen.tipoCaracterizacionSemiologicaMMII">
									</p-radioButton>
								</div>
								<div class="p-grid-border-bottom width-100">
									{{item.descripcion}}
								</div>
							</div>
						</div>
					</div>
					<app-invalid-from-message *ngIf="submitted && f.tipoCaracterizacionSemiologicaMMII.invalid">
					</app-invalid-from-message>
				</div>
				<br>
				<div *ngIf="!f.sinParticularidades.value && f.miembrosInferiores.value"
					class="p-field p-col-12 p-md-12 p-field-without-border print_row-full print_row-fill-block print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Dolor MMII: " [required]="getEnableDoloresMMII()"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{ 'ng-invalid ng-dirty': submitted && !f.dolorInsidiosoMmii.value &&
							  !f.dolorAgudoMmii.value}" [value]="true" (click)="clickRadioButton('dolorAgudoMmii')"
								formControlName="dolorAgudoMmii" label="Dolor Agudo" name="dolorAgudoMmii"
								[disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMII()" [(ngModel)]="examen.dolorAgudoMmii">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.dolorInsidiosoMmii.value &&
							  !f.dolorAgudoMmii.value}" [value]="true" (click)="clickRadioButton('dolorInsidiosoMmii')"
								formControlName="dolorInsidiosoMmii" label="Dolor Insidioso" name="dolorInsidiosoMmii"
								[disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMII()" [(ngModel)]="examen.dolorInsidiosoMmii">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message
						*ngIf="submitted && !isValidDoloresMMII()">
					</app-invalid-from-message>
				</div>
				<div *ngIf="!f.sinParticularidades.value && f.miembrosInferiores.value"
					class="p-field p-col-12 p-md-12 print_row-full print_row-fill-block print_dont_break p-field-without-border">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Curso del dolor MMII: " [required]="getEnableDoloresMMII()"></app-fiel-title>
						</div>
					</div>
					<div class="p-grid print_row-content-inline">
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty': submitted && !f.cursoContinuoMmii.value &&
							  !f.cursoBrotesMmii.value && !f.cursoCiclicoMmii.value }" [value]="true"
								(click)="clickRadioButton('cursoContinuoMmii')" formControlName="cursoContinuoMmii"
								label="Continuo" name="cursoContinuoMmii" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMII()"
								[(ngModel)]="examen.cursoContinuoMmii">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{ 'ng-invalid ng-dirty': submitted && !f.cursoContinuoMmii.value &&
							  !f.cursoBrotesMmii.value && !f.cursoCiclicoMmii.value}" [value]="true"
								(click)="clickRadioButton('cursoBrotesMmii')" formControlName="cursoBrotesMmii"
								label="Brotes" name="cursoBrotesMmii" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMII()"
								[(ngModel)]="examen.cursoBrotesMmii">
							</p-radioButton>
						</div>
						<div class="p-col-12 p-md-4">
							<p-radioButton [ngClass]="{'ng-invalid ng-dirty':submitted &&!f.cursoContinuoMmii.value &&
							  !f.cursoBrotesMmii.value  &&!f.cursoCiclicoMmii.value  }" [value]="true"
								(click)="clickRadioButton('cursoCiclicoMmii')" formControlName="cursoCiclicoMmii"
								label="Cíclico" name="cursoCiclicoMmii" [disabled]="examen?.modoVista === 'ver' || !getEnableDoloresMMII()"
								[(ngModel)]="examen.cursoCiclicoMmii">
							</p-radioButton>
						</div>
					</div>
					<app-invalid-from-message
						*ngIf="submitted && !isValidCursoMMII()">
					</app-invalid-from-message>
				</div>
			</div>

			<div *ngIf="configForm.findSection('Observaciones')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Observaciones") }}. Observaciones
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-col-12 p-md-12">
					<div class="p-grid" [ngClass]="{'print_hide-on-print': f.obsMed.value.length < 1}">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Observaciones: " class="print_hide-on-print"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('obsMed')" class="p-col-12 p-md-6 print_row-full">
							<p
								class="print_hidden-area-before-print print_show-on-print print_row-full p-field-word-break">
								{{f.obsMed.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.obsMed.invalid}" cols="30"
								formControlName="obsMed" id="result" maxlength="1000" name="resul"
								pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.obsMed.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.obsMed.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.obsMed.errors?.maxlength"
								message="Solo se permiten {{ f.obsMed.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>


			<div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Dictamen medico") }}. Dictamen médico
				</label>
				<p-divider></p-divider>

				<div class="p-grid">

					<div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

							<div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

								<p-radioButton name="codigoDictamen" [value]="item.codigo"
									formControlName="codigoDictamen" label="{{ item.descripcion }}"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
									[disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
								</p-radioButton>

							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Especialidad" required="true"></app-fiel-title>
						<p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
							[options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
							optionLabel="descripcion" optionValue="codigo" [showClear]="true"
							[disabled]="examen?.modoVista === 'ver'">
						</p-dropdown>
						<app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid">
						</app-invalid-from-message>
					</div>


					<div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Médico" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}"
							alfanumericoDirective formControlName="medicoNombre" id="medico" name="medico"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Matrícula" required="true"></app-fiel-title>

						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoMatricula.invalid}"
							numberDirective formControlName="medicoMatricula" id="medicoMatricula"
							name="medicoMatricula" maxlength="8" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoMatricula.invalid">
						</app-invalid-from-message>
					</div>
				</div>
				<div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
					</div>
					<div class="p-field p-col-12 p-md-12">
						<app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Adjuntos") }}. Archivos adjuntos
					<strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
					<span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
						{{ attachedFiles.attachedFilesValidQuantity }}
					</span>
				</label>
				<p-divider></p-divider>

				<app-attach-upload-file [examenNumero]="this.examen?.id" [isRequire]="configForm.isAttachedFileRequire"
					(filesAttachedData)="getAttachedFiles($event)" [attachedFilesFromBackend]="this.examen?.attachments"
					[viewMode]="this.examen?.modoVista" [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
				</app-attach-upload-file>

				<app-attached-file-mandatory-message
					*ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
				</app-attached-file-mandatory-message>
			</div>

			<div class="p-grid p-form-footer">
				<div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
					<ng-container *ngIf="examen?.modoVista === 'ver'">
						<button pButton pRipple type="button" label="Volver" class="p-button-text"
							(click)="goBack()"></button>
					</ng-container>

					<ng-container *ngIf="examen?.modoVista !== 'ver'">
						<button pButton pRipple type="button" label="Cancelar" class="p-button-text"
							(click)="goBack()"></button>
						<p-button type="submit" label="Guardar" *ngIf="!enviandose"
							[disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
						</p-button>
						<p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
					</ng-container>
				</div>
			</div>

			<app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.medicoEspecialidad.value"
                        [medicoMatricula]="f.medicoMatricula?.value">
      </app-print-footer>

		</div>
	</form>

	<p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC"
		styleClass="p-dialog-custom">
		<p-footer>
			<button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton
				type="button"></button>
			<button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
		</p-footer>

	</p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma"
		(closeModal)="closeModalFirma()"></app-topaz>
</section>
